import fetch from 'lib/decorated-fetch'
/**
 * 上传单张图片
 */
const uploadImg = async ({
  file,
  resolve,
  reject,
}: {
  file: File
  resolve: any
  reject: any
}) => {
  try {
    const json = await fetch('/motor/car_user/v1/get_normal_auth/')
    // @ts-ignore
    const ByteVideoUpload = (await import('byted-video-uploader')).default
    const byteVideoUploader = new ByteVideoUpload({
      debug: true,
      department: json.access_key, // 业务id,需要向视频架构组申请
      // user_id: '109005472317', // 业务方的user_id
      vasDomain: 'https://vas.snssdk.com',
      logDomain: 'https://log.snssdk.com',
      coverTime: 0, // 封面截图时间
      retryUploadTime: 5,
      retryProcessTime: 5,
      retryTaskTime: 5,
      maxProcessPause: 20,
      uploadSliceCount: 5,
      source: 8,
      source_v2: 10,
    })
    const fileKey = byteVideoUploader.addFile({
      file,
      name: 'dcd_upload_image',
      auth: json.data, // 具有时效性，每次上传前通过业务获取
      type: 'image', // 上传文件类型，两个可选值：video(视频或者音频)，image(图片)
    })
    byteVideoUploader.start(fileKey)
    byteVideoUploader.on('complete', (info: any) => {
      resolve(info.image)
    })
    byteVideoUploader.on('error', (info: any) => {
      reject('上传失败 无法解析文件')
      console.error(info)
    })
  } catch {
    reject('上传失败，请检查网络是否正常')
  }
}
/**
 * 获取图片Blob
 */
export const getImageBlob = (url: string) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('get', url, true)
    xhr.responseType = 'blob'
    xhr.onload = function() {
      if (this.status === 200) {
        resolve(this.response)
      }
    }
    xhr.onerror = function() {
      reject(new Error())
    }
    xhr.send()
  })
}

/**
 * 上传图文列表
 */
export const uploadImgList = (imgList: File[]): any => {
  return Promise.all(
    imgList.map(item => {
      return new Promise((resolve, reject) => {
        uploadImg({
          file: item,
          resolve,
          reject,
        })
      })
    })
  )
}
